// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import SomethingWentWrong from 'shared/components/SomethingWentWrong';
import PageNotFound from 'shared/components/NotFound';

// defs
import { ICMSWrapperState } from 'shared/layouts/CMSPage/types';

function API({ children, cmsData, isFetchingError, isNotFound }: ICMSWrapperState) {
  if (isEmpty(cmsData.content) && isEmpty(cmsData.jsContent)) {
    if (isNotFound) {
      return <PageNotFound />;
    }

    if (isFetchingError) {
      return <SomethingWentWrong />;
    }
  }

  return <>{children}</>;
}

export default memo(API);
